// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* modalStyles.css */

/* Modal Overlay */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

/* Modal Content */
.modal-content {
    background-color: #fff;
    padding: 20px;
    border-radius: 5px;
    width: 500px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

/* Textarea for Revoke Remarks */
.textarea {
    width: 100%;
    padding: 10px;
    margin: 10px 0;
    border-radius: 5px;
    border: 1px solid #ccc;
    resize: vertical;
}

/* Button styles */
.button {
    padding: 10px 20px;
    margin: 10px;
    border-radius: 5px;
    border: none;
    background-color: #4CAF50;
    color: #fff;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/tracktrace/revokeModalStyles.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB,kBAAkB;AAClB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA,kBAAkB;AAClB;IACI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,yCAAyC;AAC7C;;AAEA,gCAAgC;AAChC;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,eAAe;AACnB","sourcesContent":["/* modalStyles.css */\n\n/* Modal Overlay */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n/* Modal Content */\n.modal-content {\n    background-color: #fff;\n    padding: 20px;\n    border-radius: 5px;\n    width: 500px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n/* Textarea for Revoke Remarks */\n.textarea {\n    width: 100%;\n    padding: 10px;\n    margin: 10px 0;\n    border-radius: 5px;\n    border: 1px solid #ccc;\n    resize: vertical;\n}\n\n/* Button styles */\n.button {\n    padding: 10px 20px;\n    margin: 10px;\n    border-radius: 5px;\n    border: none;\n    background-color: #4CAF50;\n    color: #fff;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
